import React, { useState, useCallback, useMemo } from 'react';
import { Row, Col, Card, CardBody, Container, Spinner } from 'reactstrap';

import * as smsMessagesActions from '../../store/smsMessages/actions';
import * as leadsActions from '../../store/leads/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectLead } from '../../selectors/lead';
import Modal from '../../components/Common/Modal/Modal';
import ShowSingleElement from '../../components/Common/ShowSingleElement';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DateRangeFilter from '../../components/Common/DateRangeFilter/DateRangeFilter';
import SmsMetrics from '../../components/SmsMessages/SmsMetrics';
import DataTableNext from '../../components/Common/DataTable/DataTableNext';
import createTableColumns from '../../components/SmsMessages/tableColumns';
import {
  ExportButtonPlacement,
  ToggleColumnButton,
} from '../../components/Common/DataTable/tableActionButtons';
import { addOrRemove } from '../../helpers/sharedFunction';
import moment from 'moment';

const List = (props) => {
  const [selectedLead, setSelectedLead] = useState(null);
  const [leadModal, setLeadModal] = useState(false);
  const [selectedSmsMessage, setSelectedSmsMessage] = useState(null);
  const [smsMessageModal, setSmsMessageModal] = useState(false);

  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const loading = useSelector((state) => state.SmsMessage.loading);
  const smsMessages = useSelector((state) => state.SmsMessage.smsMessages);
  const showSelectedLead = useSelector(selectLead(selectedLead));

  const startDate = useSelector((state) => state.SmsMessage.startDate);
  const endDate = useSelector((state) => state.SmsMessage.endDate);
  const momentStartDate = startDate ? moment(startDate) : null;
  const momentEndDate = endDate ? moment(endDate) : null;

  const [selectedFilters, setSelectedFilters] = useState({
    startDate: momentStartDate || moment.utc().startOf('day'),
    endDate: momentEndDate || moment.utc(),
  });

  const dispatch = useDispatch();

  const refresh = useCallback(({ startDate, endDate }) => {
    const selectedStartDate = startDate.utc().startOf('day').toDate();
    const selectedEndDate = endDate.utc().endOf('day').toDate();
    dispatch(
      smsMessagesActions.fetchSmsMessages(selectedStartDate, selectedEndDate),
    );
    setSelectedFilters({ startDate, endDate });
  });

  const openLeadModal = (smsMessage) => {
    setSelectedLead(smsMessage.leadId);
    !showSelectedLead &&
      dispatch(leadsActions.fetchSingleLead(smsMessage.leadId));
    setLeadModal(true);
  };

  const openSmsMessageModal = (smsMessage) => {
    setSelectedSmsMessage(smsMessage);
    setSmsMessageModal(true);
  };

  const columns = useMemo(
    () => createTableColumns(openLeadModal, openSmsMessageModal),
    [],
  );
  const [hiddenColumns, setHiddenColumns] = useState(
    columns.filter(({ hidden }) => !!hidden).map(({ name }) => name),
  );
  const handleToggleColumn = (name) => {
    setHiddenColumns(addOrRemove(hiddenColumns, name));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="Sms Messages"
            breadcrumbItem="List"
            onRefresh={() => refresh(selectedFilters)}
            loading={loading}
          />
          <DateRangeFilter
            onUpdate={refresh}
            startDate={selectedFilters.startDate}
            endDate={selectedFilters.endDate}
            loading={loading}
          />
          <Row>
            <SmsMetrics loading={loading} />
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="align-items-center justify-content-end mb-2">
                    <Spinner
                      color="secondary"
                      animation="border"
                      hidden={!loading}
                    />
                    <ToggleColumnButton
                      columns={columns}
                      hiddenColumns={hiddenColumns}
                      onToggleColumn={handleToggleColumn}
                    />
                    <ExportButtonPlacement />
                  </Row>
                  <DataTableNext
                    loading={loading}
                    rows={smsMessages}
                    columns={columns}
                    filters={filters}
                    onFiltersChange={setFilters}
                    sorting={sorting}
                    onSortingChange={setSorting}
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    hiddenColumns={hiddenColumns}
                    onHiddenColumnsChange={setHiddenColumns}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="xl"
            title="Lead"
            isOpen={leadModal}
            toggle={() => setLeadModal(!leadModal)}
            showClose
            scrollable={false}>
            <ShowSingleElement
              element={showSelectedLead}
              icon="bx bx-user-pin"
            />
          </Modal>
          <Modal
            size="lg"
            title="Sms Message"
            isOpen={smsMessageModal}
            toggle={() => setSmsMessageModal(!smsMessageModal)}
            showClose
            scrollable={false}>
            <ShowSingleElement
              element={selectedSmsMessage}
              icon="bx bx-message-square-detail"
            />
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default List;
